import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    formLayout: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: 0,
        overflow: "hidden",
    },
    containerWrapper: {
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        padding: 0,
    },
    stepper: {
        flexShrink: 0,
        padding: theme.spacing(2, 3),
        borderBottom: `1px solid ${theme.palette.emteria.border.primary}`,
    },
}));
